import { useMemo } from 'react';
import useTheme from 'branding/theme';
import useComponentMargin from '../../hooks/useComponentMargin';
const useLinkButtonStyles = ({ size, width, variant, noDefaultMargin, isHovered, isFocused, styles }) => {
    const { colors, inputs: { base, shape, size: inputSize, width: inputWidth, buttonStyles } } = useTheme();
    const marginStyles = useComponentMargin({ marginVertical: 'small' });
    const aTagButtonizeStyles = useMemo(() => ({
        display: 'inline-block',
        textDecoration: 'none',
        textAlign: 'center',
        backgroundClip: 'border-box'
    }), []);
    return useMemo(() => ({
        ...base,
        ...shape.pill,
        ...inputSize[size],
        ...inputWidth[width],
        ...buttonStyles.base,
        ...buttonStyles.variant[variant],
        ...((isHovered || isFocused) && buttonStyles.hovered[variant]),
        ...(variant === 'secondary' && { borderColor: colors.neutrals.transparent }),
        ...(!noDefaultMargin && marginStyles),
        ...aTagButtonizeStyles,
        ...styles
    }), [
        base,
        shape,
        inputSize,
        buttonStyles,
        aTagButtonizeStyles,
        colors,
        styles,
        size,
        variant,
        isFocused,
        isHovered,
        inputWidth,
        width,
        noDefaultMargin,
        marginStyles
    ]);
};
export default useLinkButtonStyles;
//# sourceMappingURL=useLinkButtonStyles.js.map